module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/my-home-illustration-c1fb2f25ee9a6e731378b3248911128c.svg";